import React, { useEffect, useLayoutEffect, useState } from 'react'
import Webcam from 'react-webcam'
import logo from './logo.svg';
import './App.css';
import Step from './Components/Step';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage, setMandate, setMandateData, setMobileMode, setPartner, setShowLanguage, setUserType, setVertical, setmandateID } from './Components/MandateSlice';
import Login from './Components/Login';
import OTP from './Components/OTP';
import PaymentSystem from './Components/PaymentSystem';
import Kotakmandate from './Components/Kotakmandate';
import UPI_Mandate from './Components/UPI_Mandate';
import MandateOpt from './Components/MandateOpt';
import Success from './Components/Success';
import Expiry from './Components/Expiry';
import { SnackbarProvider } from 'notistack';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import greenTick from './Images/GreenTick.svg'
import Language from './Components/Language';

function App() {
  const dispatch = useDispatch()
  const { mandateData, mandateID, language, showLanguage } = useSelector((state) => state.mandateInfo);
  const { partner } = useSelector((state) => state.mandateInfo);
  const [partnerType, setPartnerType] = useState()
  const [failure, setFailure] = useState(false)
  const [mid, setMid] = useState()
  const [lang, setLang] = useState()
  const parseURL = () => {
    const getMobileDetail = getMobileOperatingSystem();
    dispatch(setMobileMode(getMobileDetail));
    let url = new URL(window.location.href).searchParams;
    const mid = url.get("mid");
    const mandateType = url.get("mandate");
    const lang = url.get('lang')
    const vertical = url.get('vertical')
    const userType = url.get('type') ? url.get('type') : 'LAP'
    dispatch(setLanguage(lang))
    if(lang){
      dispatch(setShowLanguage(false))
    }
    setMid(mid)
    mid ? sessionStorage.setItem('id', mid) : sessionStorage.getItem("id")
    dispatch(setmandateID(mid))
    dispatch(setUserType(userType))
    dispatch(setPartner(mandateType))
    mandateType === 'chola-web' && sessionStorage.setItem('partner', mandateType)
    dispatch(setVertical(vertical))
  }

  const languageDetails = [{ "name": "English", "code": "en" }, { "name": "Tamil", "code": "ta" }, { "name": "Hindi", "code": "hn" }, { "name": "Malayalam", "code": "ma" }, { "name": "Telugu", "code": "te" }, { "name": "Kanada", "code": "ka" }]

  i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: language,
    resources: {
      en: {
        translations: require('./locales/en/translation.json')
      },
      ta: {
        translations: require('./locales/ta/translation.json')
      }
    },
    ns: ['translations'],
    defaultNS: 'translations'
  });

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

  // useEffect(() => {
  //   axios({
  //     url: process.env.REACT_APP_RESPONSE,
  //     method: 'post',
  //     headers: {
  //       "Access-Control-Allow-Origin": "*",
  //       'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
  //     },
  //     data: { 'unique_id': mid }
  //   }).then((res) => { 
  //     if (res?.data?.Status === "Failure") { 
  //       setFailure(true) 
  //     } 
  //     res ? dispatch(setMandateData(res?.data)) : dispatch(setMandateData()) })
  // },[mandateID])

  useLayoutEffect(() => {
    parseURL();
  }, [])

  // useEffect(() => {
  //   if (partner === "chola-web") {
  //     axios({
  //       url: process.env.REACT_APP_API_COMMON + "cselMandate/prefill",
  //       method: 'post',
  //       headers: {
  //         "Access-Control-Allow-Origin": "*",
  //         'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
  //       },
  //       data: {
  //         "Source_Sys": "chola-web",
  //         "callback_url": "https://gaadibazaar.co.in/"
  //       }
  //     }).then((res) => {
  //       const getUniqueKey = res?.data?.url.split('=')
  //       dispatch(setmandateID(getUniqueKey[getUniqueKey.length - 1]))
  //     })
  //   }
  // }, [partner])

  return (
    // <Login/>
    // <OTP/>
    <>
      <SnackbarProvider maxSnack={1}>
        {mandateData?.UMRNNumber && <Success/>}
        {(mandateData?.Status !== "Failure" && !mandateData?.UMRNNumber) && mandateData && <Step />}
        {mandateData?.Status === "Failure" && <Expiry />}
        {/* {showLanguage && <Language/>} */}
      </SnackbarProvider>
    </>
    // <BrowserRouter>
    //   <Routes>
    //     <Route path="/payment" element={<PaymentSystem />} />
    //     <Route path="/login" element={<Login />} />
    //     <Route path="/*" element={<Login />} />
    //     <Route path="/otp" element={<OTP />} />
    //     <Route path="/kotak-mandate" element={<Kotakmandate />} />
    //     <Route path="/upi-mandate" element={<UPI_Mandate />} />
    //     <Route path="/mandate-options" element={<MandateOpt />} />
    //     <Route path="/success" element={<Success />} />
    //   </Routes>
    // </BrowserRouter>
  )
}

export default App;
